<template>
  <div
    ref="printReceiptDom"
    class="pageWrap"
    :class="{'preview':isPreview}"
  >
    <div
      v-for="(val, ind) in receiptData"
      :key="ind"
      class="page"
    >
      <div
        v-for="half in 2"
        :key="half"
        class="pageHalf"
      >
        <div class="titleWrap">
          {{ val.BillCommitteeName }}繳費收據
          <span v-if="half==1">(收執聯)</span>
          <span v-if="half==2">(存根聯)</span>
          {{ val.ReceiptPrintCount ? `(${$t('Fee.Receipt.Reissue')}${val.ReceiptPrintCount})` : '' }}
        </div>
        <div class="descWrap">
          <div class="item">
            <div class="title">
              期別：
            </div>
            <div class="content">
              {{ val.BillBulkName }}
            </div>
          </div>
          <div class="item">
            <div class="title">
              銷帳編號：
            </div>
            <div class="content">
              {{ val.ReceiptSn }}
            </div>
          </div>
          <div class="item">
            <div class="title">
              收據編號：
            </div>
            <div class="content">
              {{ val.ReceiptRn }}
            </div>
          </div>
          <div class="item">
            <div class="title">
              戶別代碼：
            </div>
            <div class="content">
              {{ val.TabletNote }}
            </div>
          </div>
          <div class="item">
            <div class="title">
              所有權人：
            </div>
            <div class="content">
              {{ val.BillOwner }}
            </div>
          </div>
          <div class="item">
            <div class="title">
              繳費日期：
            </div>
            <div class="content">
              {{ val.ReceiptPayDate }}
            </div>
          </div>
        </div>
        <div class="formWrap">
          <div class="leftWrap">
            <div class="left">
              <div class="item head">
                <div class="text name">
                  項目明細
                </div>
                <div class="text amount">
                  金額
                </div>
              </div>
              <div
                v-for="(v, i) in [...val.BillTerms,...new Array(10-val.BillTerms.length)].slice(0, 5)"
                :key="i"
                class="item"
              >
                <div class="text name">
                  {{ v&&v.Name }}
                </div>
                <div class="text amount">
                  {{ v&&'$ '+thousandComma(v.Amount) }}
                </div>
              </div>
            </div>
            <div class="right">
              <div class="item head">
                <div class="text name">
                  項目明細
                </div>
                <div class="text amount">
                  金額
                </div>
              </div>
              <div
                v-for="(v, i) in [...val.BillTerms,...new Array(10-val.BillTerms.length)].slice(5, 10)"
                :key="i"
                class="item"
              >
                <div class="text name">
                  {{ v&&v.Name }}
                </div>
                <div class="text amount">
                  {{ v&&'$ '+thousandComma(v.Amount) }}
                </div>
              </div>
            </div>
            <div class="bottom">
              <div class="item head">
                <div class="text">
                  應繳總額
                </div>
                <div v-if="val.HandlingFeeMode === 'Attach'" class="text">
                  {{ $t('Fee.Receipt.HandlingFee') }}
                </div>
                <div class="text">
                  {{ $t('Fee.Receipt.AmountPaid') }}
                </div>
              </div>
              <div class="item">
                <div class="text">
                  {{ val.BillShouldAmount ? '$ '+thousandComma(val.BillShouldAmount) : '$ 0' }}
                </div>
                <div v-if="val.HandlingFeeMode === 'Attach'" class="text">
                  {{ val.HandlingFee ? '$ '+thousandComma(val.HandlingFee) : '$ 0' }}
                </div>
                <div class="text">
                  {{ val.TotalPaymentAmount ? '$ '+thousandComma(val.TotalPaymentAmount) : '$ 0' }}
                </div>
              </div>
            </div>
          </div>
          <div class="rightWrap">
            <div class="left">
              <div class="head">
                備註
              </div>
              <div
                class="box"
                :class="[ val.HandlingFeeMode === 'Attach' ? 'eight-cols' : 'seven-cols']"
              >
                {{ val.ReceiptNote }}
              </div>
            </div>
            <div class="right">
              <div class="head">
                管理中心用印
              </div>
              <div
                class="box"
                :class="[ val.HandlingFeeMode === 'Attach' ? 'eight-cols' : 'seven-cols']"
              />
            </div>
          </div>
          <div class="bottomWrap">
            {{ val.ConfigCommunityBillBulkTemplateReceiptNote }}
          </div>
        </div>
        <div
          v-if="half==1"
          class="signatureWrapOne"
        >
          <div class="name">
            經辦人：
          </div>
        </div>
        <div
          v-if="half==2"
          class="signatureWrap"
        >
          <div class="name">
            主任委員：
          </div>
          <div class="name">
            財務委員：
          </div>
          <div class="name">
            監察委員：
          </div>
          <div class="name">
            經辦人：
          </div>
          <div class="name">
            {{ $t('Fee.Receipt.Printer') }}：{{ val.PrintedBy }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    isPreview: Boolean
  },
  data () {
    return {
      receiptData: []
    }
  },
  computed: {

  },
  methods: {
    print () {
      this.$print(this.$refs.printReceiptDom)
    },
    getReceiptData (bulkId, billId, receiptId) {
      const loading = this.$loading()
      if (this.isPreview) { // 預覽收據
        apiBillservice.Config.GetCommunitySettingForm(
        ).then((res) => {
          this.receiptData = [{
            BillBulkName: '2019年4-6月管理費',
            BillCommitteeName: res.data.Data.CommunityBillBulkTemplate.CommitteeInfoName,
            BillOwner: '陳曉明',
            TabletNote: '142號5樓之1',
            BillShouldAmount: 11400,
            ReceiptId: 0,
            ReceiptRn: '00000325',
            ReceiptSn: '00000325',
            ReceiptPayDate: '2019/01/15',
            ReceiptAmount: 11400,
            ReceiptNote: '1.繳費備註1\n2.繳費備註2\n3.繳費備註3\n',
            ReceiptPrintCount: 0,
            ConfigCommunityBillBulkTemplateReceiptNote: res.data.Data.CommunityBillBulkTemplate.ReceiptNotice,
            BillTerms: [
              { Name: '前期補收', Amount: 1000 },
              { Name: '管理費', Amount: 3000 },
              { Name: '水瓦費', Amount: 500 },
              { Name: '停車費', Amount: 1200 },
              { Name: '停車費', Amount: 1200 },
              { Name: '停車費', Amount: 1000 },
              { Name: '管理費', Amount: 3000 },
              { Name: '水瓦費', Amount: 500 },
              { Name: '停車費', Amount: 1200 },
              { Name: '停車費', Amount: 1200 }
            ]
          }]
          loading.close()
        }).catch((err) => {
          console.log(err.response)
          loading.close()
          this.$message({
            message: '取得繳費單基本設定失敗，請稍後再試',
            type: 'warning'
          })
        })
      } else { // 列印收據
        const queryPath = {
          billBulkId: bulkId,
          billId
        }
        const requestData = receiptId
        apiBillservice.BillBulk.GetBillReceiptPrint(
          queryPath,
          requestData
        ).then((res) => {
          this.receiptData = res.data.Data.map((e) => {
            e.ReceiptPayDate = this.$formatDate(e.ReceiptPayDate)
            e.HandlingFeeMode = e.ConfigHandlingFeeModeId
            return e
          })
          this.$nextTick(() => {
            loading.close()
            this.print()
          })
        }).catch((err) => {
          console.log(err.response)
          loading.close()
          this.$message({
            message: '取得收據失敗，請稍後再試',
            type: 'warning'
          })
        })
      }
    },
    getMultipleReceiptData (billIds) {
      const loading = this.$loading()
      const requestData = {
        Ids: billIds
      }
      apiBillservice.Bill.PutBillReceiptPrint(
        requestData
      ).then((res) => {
        this.receiptData = res.data.Data.Writeoffs.map((e) => {
          e.ReceiptPayDate = this.$formatDate(e.PayTime)
          e.BillOwner = e.Owner
          e.ReceiptSn = e.WriteoffSn
          e.ReceiptRn = e.ReceiptNumber
          e.ConfigHandlingFeeModeShowName = e.HandlingFeeModeName || ''
          e.BillShouldAmount = e.ShouldAmount
          e.ReceiptAmount = e.Amount
          e.ConfigCommunityBillBulkTemplateReceiptNote = e.ReceiptNotice
          e.BillCommitteeName = e.CommitteeName
          return e
        })
        this.$nextTick(() => {
          loading.close()
          this.print()
        })
      }).catch((err) => {
        console.log(err)
        loading.close()
        this.$message({
          message: this.$t('Fee.Receipt.GetFail'),
          type: 'warning'
        })
      })
    },
    thousandComma (number) { // 產出金額三位逗號
      let num = number.toString()
      const pattern = /(-?\d+)(\d{3})/
      // 整數 [0-9]+ = \d+
      // ?  匹配前面的子運算式零次或一次。例如，“do(es)?”可以匹配“do”或“does”中的“do”。?等價於{0,1}。
      // $1 = (-?\d+) $2 = (\d{3})
      // \d 匹配一個數位字元。等價於[0-9]。
      // {n} n是一個非負整數。匹配確定的n次。例如，“o{2}”不能匹配“Bob”中的“o”，但是能匹配“food”中的兩個o。
      while (pattern.test(num)) {
        num = num.replace(pattern, '$1,$2')
      }
      return num
    }
  }
}
</script>
<style lang="scss" scoped>
*{
  box-sizing: border-box;
  font-family: "Century Gothic", Arial, 微軟正黑體, 新細明體, sans-serif;
  overflow: hidden;
}
.pageWrap {
  font-family: "Century Gothic", Arial, 微軟正黑體, 新細明體, sans-serif;
  font-size: 13px;
  color: #4b4b4b;
  display: none;
  .page {
    width: 210mm;
    height: 297mm;
    padding: 20px 15px 0px;
    box-sizing: border-box;
    margin: 0 auto;
    border: 1px #d3d3d3 solid;
    border-radius: 5px;
    background: white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    position: relative;
    .pageHalf{
      height: 144.5mm;
      padding: 30px 30px 0;
      &:first-child{
        border-bottom: 1px dashed #666;
      }
      .titleWrap{
        text-align: center;
        font-size: 19px;
        margin-bottom: 30px;
        line-height: 1.2;
      }
      .descWrap{
        display: inline-flex;
        flex-wrap: wrap;
        .item{
          display: flex;
          width: 33.33%;
          margin-bottom: 10px;
          padding: 0 3px;
        }
      }
      .title{
        font-size: 14px;
        font-weight: bold;
        white-space: nowrap;
      }
      .content{
        font-size: 13px;
        font-weight: normal;
        word-break: break-all;
        flex: 1;
      }
      .formWrap{
        display: flex;
        flex-wrap: wrap;
        // border: solid 2px #aaa;
        box-sizing: border-box;
        .leftWrap{
          width: 60%;
          display: inline-flex;
          flex-wrap: wrap;
          .left,.right{
            width: 50%;
            .item{
              display: flex;
              .text{
                display: flex;
                justify-content: center;
                align-items: center;
                height: 30px;
                border-top: solid 1px #aaa;
                border-left: solid 1px #aaa;
                &.name{
                  width: 50%;
                }
                &.amount{
                  width: 50%;
                }
              }
            }
          }
          .bottom{
            display: flex;
            flex-direction: row;
            width: 100%;
            .item{
              display: flex;
              flex-direction: column;
              width: 50%;
              .text{
                display: flex;
                justify-content: center;
                align-items: center;
                height: 30px;
                border-top: solid 1px #aaa;
                border-left: solid 1px #aaa;
              }
            }
          }
        }
        .rightWrap{
          width: 40%;
          display: flex;
          .left{
            width: 50%;
            .box{
              padding: 6px 10px;
            }
          }
          .right{
            width: 50%;
            .head{
              border-right: solid 1px #aaa;
            }
            .box{
              border-right: solid 1px #aaa;
            }
          }
          .head{
            display: flex;
            justify-content: center;
            align-items: center;
            height: 30px;
            border-top: solid 1px #aaa;
            border-left: solid 1px #aaa;
          }
          .box{
            border-top: solid 1px #aaa;
            border-left: solid 1px #aaa;

            &.seven-cols {
              height: 210px;
            }
            &.eight-cols {
              height: 240px;
            }
          }
        }
        .bottomWrap{
          width: 100%;
          height: 100px;
          border: solid 1px #aaa;
          text-align: left;
          padding: 6px 10px;
          white-space: pre-line;
          line-height: 1.3
        }
      }
      .signatureWrapOne{
        display: flex;
        justify-content: flex-end;
        padding: 15px 0;
        .name{
          flex-basis: 20%;
          text-align: left;
        }
      }
      .signatureWrap{
        display: flex;
        padding: 15px 0;
        .name{
          flex: 1;
          text-align: left;
        }
      }
    }
  }
}

.pageWrap.preview {
  display: block;
  .page {
    &:after {
      content:"範本";
      position:absolute;
      display:block;
      width:50%;
      height:50%;
      top:0;
      bottom:0;
      left:0;
      right:0;
      margin:auto;
      color:#eb6d6d;
      opacity:.1;
      text-align:center;
      font-size:200px;
      line-height:1.5;
    }
  }
}
@page {
  size: 210mm 297mm;
  margin: 0mm;
}
@media print {
  .pageWrap {
    color: #000000;
    box-sizing: border-box;
    display: block;
    .page {
      margin: 0;
      border: initial;
      border-radius: initial;
      width: initial;
      height: initial;
      box-shadow: initial;
      /* background: initial; */
      page-break-after: always;
      color: #000000;
      *{
        outline-color: #000000!important;
        border-color: #000000!important;
      }
    }
  }
}
</style>
